import { BuilderVismaElementProps } from "../BuilderInterface";
import "./style.scss";
import { getCompoundStyle } from "../helpers";
import classNames from "classnames";

export enum VismaState {
    DEFAULT = "default",
    ERROR = "error",
    LOADING = "loading",
    SUCCESS = "success"
}

const BuilderVismaElement = ({ node, builderProps, children }: BuilderVismaElementProps) => {
    const { id, attr } = node;

    const vismaElementClass = classNames("visma-element-wrapper", {
        [`${attr?.className}`]: !!attr?.className
    });

    if (builderProps) {
        const { selectCallback, outlineCallback } = builderProps;

        return (
            <div
                className={vismaElementClass}
                style={getCompoundStyle({
                    node
                })}
                onClick={e => (selectCallback ? selectCallback(e, id) : {})}
                onMouseMove={e => (outlineCallback ? outlineCallback(e, id) : {})}
                id={id}
                draggable="false"
            >
                {children}
            </div>
        );
    } else {
        return (
            <div
                className={vismaElementClass}
                style={getCompoundStyle({
                    node
                })}
            >
                {children}
            </div>
        );
    }
};

export default BuilderVismaElement;
